import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  Alert
} from "react-bootstrap";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createBrowserHistory } from "history";
import { NewBreadcrumb as BreadcrumbComponent } from "../../../components";
import isEmpty from "lodash.isempty";
import CountryStateCity from "../../../components/countryStateCity/CountryStateCity";
import {
  add_faq,
  get_faq_details,
  update_faq
} from "../../../redux/actions/faqAction";
import loader from "../../../style/loader/loader.scss";
import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";
import {aclUtil} from "../../util"

let isLoading = false;
const history = createBrowserHistory();
class addFaq extends Component {
  static contextTypes = {
    router: PropTypes.object
  }
  constructor(props) {
    super(props);
    this.state = {
      menuKey: 'ADD_FAQ',
      alertMessage: "",
      msgType: "",
      show: false,
      question: "",
      weight: 0,
      answer: "",
      status: "Active",
      questionError: "",
      answerError: "",
      quesID: "",
      path: ["Home","Manage FAQ", "Add FAQ"],
      links:["home", "faqList", "addFaq"],
      isError: false,
      french_question: '',
      french_answer : '',
      multi_lang: 'no',
    };
    this.validate = this.validate.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.clear = this.clear.bind(this);
  }

  handleChange(e) {
    e.preventDefault();
    if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }
    this.setState({ [e.target.name]: e.target.value });
  }

  handleEdit = () => {
    this.setState({ hideForm: false });
  };

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  clear() {
    this.setState({
      status: "Active",
      question: "",
      answer: "",
      weight: "",
      questionError: "",
      answerError: "",
      french_question: "",
      french_answer : "",
    });
  }

  handleSubmit(e) {
    e.preventDefault();
    const err = this.validate();
    if (!err) {
      if (this.state.quesID !== "") {
        const updateData = {
          quesID: this.state.quesID,
          question: this.state.question,
          answer: this.state.answer,
          status: this.state.status,
          weight: this.state.weight,
          french_question: this.state.french_question,
          french_answer : this.state.french_answer,
        };

        this.props.update_faq(updateData);
      } else {
        const addData = {
          question: this.state.question,
          answer: this.state.answer,
          status: this.state.status,
          weight: this.state.weight,
          french_question: this.state.french_question,
          french_answer : this.state.french_answer,
        };

        this.props.add_faq(addData);
      }
    }
  }

  validate = () => {
    let isError = false;
    const errors = {};
    if (this.state.question.length === 0) {
      isError = true;
      this.setState({ questionError: "red" });
    }
    if (this.state.answer.length === 0) {
      isError = true;
      this.setState({ answerError: "red" });
    }
    return isError;
  };

  componentWillMount() {
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));

    if(siteData){
      if(siteData.multi_lang){
        this.setState({
          multi_lang: siteData.multi_lang
        });
      }
    }
    let quesIDParams = this.props.match.params.quesID
      ? this.props.match.params.quesID
      : "";
    const editLink = this.props.match.params.quesID && `editFaq/${this.props.match.params.quesID}`
    if (quesIDParams !== "") {
      this.setState({ quesID: quesIDParams });

      this.props.get_faq_details(quesIDParams);
      this.state.path = ["Home", "Manage Merchant", "Edit FAQ"];
      this.state.links = ["home", "faqList", editLink];
    }
  }
  componentWillReceiveProps(nextProps) {
    let tmpAclKey = this.state.menuKey;
    if(this.props.match.params.quesID){
      tmpAclKey = 'EDIT_FAQ';
    }
    if(!aclUtil.isPrimaryMenuAccessible(tmpAclKey)){
      this.context.router.history.push("/restrictedAccess");
    }

    if (this.props.addFaqResponse !== nextProps.addFaqResponse) {
      this.props.clearAlert();
      this.handleShow();
      this.props.renderAlert("success", nextProps.addFaqResponse.message);
      window.scrollTo(0, 0);
      this.clear();
    }
    if (
      this.props.faqDetails !== nextProps.faqDetails &&
      !isEmpty(nextProps.faqDetails)
    ) {
      this.setState({
        quesID: nextProps.faqDetails.quesID,
        question: nextProps.faqDetails.question,
        answer: nextProps.faqDetails.answer,
        weight: nextProps.faqDetails.weight,
        status: nextProps.faqDetails.status,
        french_question: nextProps.faqDetails.french_question,
        french_answer : nextProps.faqDetails.french_answer,
      });
    }
    if (this.props.message !== nextProps.message) {
      this.handleShow();
      this.setState({ alertMessage: nextProps.message });
      window.scrollTo(0, 0);
    }
    if (this.props.alertType !== nextProps.alertType) {
      this.handleShow();
      this.setState({ msgType: nextProps.alertType });
      window.scrollTo(0, 0);
    }
    if (this.props.error !== nextProps.error && nextProps.error.length > 0) {
      this.props.clearAlert();
      this.handleShow();
      this.props.renderAlert("warning", nextProps.error);
      this.setState({ msgType: "warning" });
      window.scrollTo(0, 0);
    }
    if (this.props.updateFaqResponse !== nextProps.updateFaqResponse) {
      this.props.clearAlert();
      this.handleShow();
      this.props.renderAlert("success", nextProps.updateFaqResponse.message);
      this.setState({ msgType: "success" });
      window.scrollTo(0, 0);
      this.props.get_faq_details(this.state.quesID);
    }
  }

  render() {
    return (
      <div className="addFaq col-lg-12 col-md-12 col-sm-12 col-xs-12">
        {this.props.receivingDetails ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1" />
              <div className="dot2" />
            </div>
          </div>
        ) : (
          ""
        )}
        <div className="row">
          {this.state.show &&
            this.state.alertMessage !== "" && (
              <div className="col-lg-12">
                <Alert
                  bsStyle={this.state.msgType}
                  onDismiss={this.handleDismiss}
                >
                  <strong>{this.state.msgType}:</strong>{" "}
                  {this.state.alertMessage}
                </Alert>
              </div>
            )}
          <div className="col-xs-12">
            <BreadcrumbComponent path={this.state.path} links={this.state.links} context={this.context}/>
          </div>
        </div>
        <div className="panel">
          <header className="panel-heading">Add FAQ</header>
          <div className="panel-body">
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <Row>
                <Col md={8} xs={12} mdOffset={2}>
                  <form onSubmit={this.handleSubmit}>
                    <Row>
                      <Col md={12} xs={12}>
                        <FormGroup controlId="formQuestion">
                          <ControlLabel>
                            <span style={{ color: "red" }}>*</span>Question
                          </ControlLabel>
                          <FormControl
                            type="text"
                            value={this.state.question}
                            onChange={this.handleChange}
                            name="question"
                            placeholder="Question"
                            style={{ borderColor: this.state.questionError }}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    {(this.state.multi_lang == "yes") &&
                    <Row>
                      <Col md={12} xs={12}>
                        <FormGroup controlId="formQuestion">
                          <ControlLabel>
                            <span style={{ color: "red" }}>*</span>Question (Canadian French)
                          </ControlLabel>
                          <FormControl
                            type="text"
                            value={this.state.french_question}
                            onChange={this.handleChange}
                            name="french_question"
                            placeholder="Question (Canadian French)"
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    }
                    <Row>
                      <Col md={12} xs={12}>
                        <FormGroup controlId="formAnswer">
                          <ControlLabel>
                            <span style={{ color: "red" }}>*</span>Answer
                          </ControlLabel>
                          <FormControl
                            value={this.state.answer}
                            componentClass="textarea"
                            onChange={this.handleChange}
                            name="answer"
                            placeholder="Answer"
                            style={{ borderColor: this.state.answerError }}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    {(this.state.multi_lang == "yes") &&
                    <Row>
                      <Col md={12} xs={12}>
                        <FormGroup controlId="formAnswer">
                          <ControlLabel>
                            <span style={{ color: "red" }}>*</span>Answer (Canadian French)
                          </ControlLabel>
                          <FormControl
                            value={this.state.french_answer}
                            componentClass="textarea"
                            onChange={this.handleChange}
                            name="french_answer"
                            placeholder="Answer (Canadian French)"
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    }
                    <Row>
                      <Col md={12} xs={12}>
                        <FormGroup controlId="formweight">
                          <ControlLabel>Weight</ControlLabel>
                          <FormControl
                            type="number"
                            value={this.state.weight}
                            onChange={this.handleChange}
                            name="weight"
                            placeholder="Weight"
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={12} xs={12}>
                        <FormGroup controlId="formControlsSelect">
                          <ControlLabel>Status</ControlLabel>
                          <FormControl
                            componentClass="select"
                            placeholder="Status"
                            name="status"
                            value={this.state.status}
                            onChange={this.handleChange}
                          >
                            <option value="Active">Active</option>
                            <option value="Inactive">Inactive</option>
                          </FormControl>
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row className="BtnRow">
                      <Col md={12} xs={12}>
                        <Button
                          bsStyle="info"
                          type="submit"
                          id="submitButton"
                          disabled={this.props.sending}
                        >
                          Submit
                        </Button>
                        <Button
                          bsStyle="default"
                          onClick={() => this.context.router.history.push(`/faqList`)}
                        >
                          Cancel
                        </Button>
                      </Col>
                    </Row>
                  </form>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

addFaq.propTypes = {
  add_faq: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  sending: state.faqReducer.sending,
  error: state.faqReducer.error,
  message: state.alertsReducer.message,
  alertType: state.alertsReducer.alertType,
  addFaqResponse: state.faqReducer.addFaqResponse,
  faqDetails: state.faqReducer.faqDetails,
  updateFaqResponse: state.faqReducer.updateFaqResponse,
  receivingDetails: state.faqReducer.receivingDetails
});
export default compose(
  withRouter, // IMPORTANT: witRouter is "needed here" to avoid blocking routing:
  connect(mapStateToProps, {
    add_faq,
    get_faq_details,
    update_faq,
    clearAlert,
    renderAlert
  })
)(addFaq);



// WEBPACK FOOTER //
// ./src/app/views/admin/faq/addFaq.js